import type { GridApiPremium } from "@mui/x-data-grid-premium";
import type { Dispatch, SetStateAction } from "react";
import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { DataCatalogueEntityType, FileInfo } from "../../../api/types/fileTypes";
import type { FilesState } from "./filesState";

export interface FilesContextValue {
  filesState: FilesState;
  setFilesState: Dispatch<SetStateAction<FilesState>>;
  gridApiRef: React.RefObject<GridApiPremium | null>;
  hasPermissionsToManage: boolean;
  entityInfo: EntityInfo | undefined;
  onDownloadFile: (row: FileInfo) => void;
  onDownloadMultipleFiles: (catalogueIds: string[]) => void;
  onPreviewFile: (row: FileInfo) => void;
  onDeleteFile: (row: FileInfo) => void;
  onDeleteMultipleFiles: (catalogueIds: string[]) => void;
}

export interface EntityInfo {
  entityType: DataCatalogueEntityType;
  entityId: string;
  entityName: string;
  objectType?: string;
}

export const FilesContext = createContext<FilesContextValue | undefined>(undefined);

export const useFilesContext = () => defined(use(FilesContext), "Attempt to use FilesContext without provider");
